import { IAutomationObject } from '../../types'
import { schemaFilter, schemaFreeze, schemaMotion, schemaRepairSwitch, schema as schemaDigAlarm } from '../SensorDigitalAlarm/types';
import {  schema as schemaDigFault } from '../SensorDigitalFault/types';
import {  schema as schemaDigInfo } from '../SensorDigitalInformation/types';
import {  schema as schemaDigMaint } from '../SensorDigitalMaintenance/types';

export interface ISensorDigital extends IAutomationObject {
    isOn: boolean;
    onValueChanged: any;
    overridden: boolean;
    outOfService: boolean;
    noSensor: boolean;
    communicationFailure: boolean;
}

export const schema = 'AutomationApps.Devices.Sensors.SensorDigital';


export const isDigitalSensor = (schemaInput: string) => {
    return schemaInput === schema ||
    schemaInput === schemaFilter ||
    schemaInput === schemaFreeze ||
    schemaInput === schemaRepairSwitch ||
    schemaInput === schemaMotion ||
    schemaInput === schemaDigAlarm ||
    schemaInput === schemaDigFault ||
    schemaInput === schemaDigInfo ||
    schemaInput === schemaDigMaint
}